import styled from "styled-components";

const CenteredPage = styled.div`
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
`;

export default CenteredPage;
